import { useMemo } from 'react'
import { useTranslation } from 'react-i18next'

// Plain string-returning translator. i18next types `t` as returning
// `DefaultTFuncReturn` (string | null), which DOM attributes and ColumnDef
// headers reject. For string keys with interpolation values, `t` returns a
// string at runtime, so the cast is safe and keeps call sites clean.
export type Translate = (
  key: string,
  options?: Record<string, unknown>,
) => string

export default function useTranslate(): Translate {
  const { t } = useTranslation()
  return useMemo(() => t as unknown as Translate, [t])
}
